@import '../../styles/palette.scss';
@import '../../styles/fonts.scss';

.version {
  @include barlowMedium(16);
  color: _palette(secondary);
  text-transform: capitalize;
}
